import React, { Component, Fragment } from 'react';

import './style.scss';
import { Page } from '../../common/ui';
import ModalMail from '../../common/modal/modalMail';
import ModalUser from '../../common/modal/modalUser';
import Modal from '../../common/modal';
import UserHeader from '../components/userHeader';
import ContentDetailUser from '../components/detailUserContent';
import { isEmpty, withLocation, withNavigate } from '../../utility';

/**
 * Id dell'utente dall'url (/userInDetail/:userId). Va decodificato: un link copiato può contenere %40 al posto di @.
 */
function userIdFromPath(pathname) {
    const segment = pathname.split('/')[2] || '';
    try {
        return decodeURIComponent(segment);
    } catch (e) {
        return segment;
    }
}

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,

            // contiene la lista degli utenti restituita dopo la chiamata al BE
            getUserList: [],

            titleModal: '',
            contentModal: '',
            actionModal: '',
            modalMail: false,
            modal: false,
            editUser: false,
            editRole: false,
            editGroup: false,
            role: null,

            // informazioni dell'utente che apparirà nel dettaglio
            userInDetail: {
                id: '',
                registrationIp: '',
                email: '',
                lastLogOn: '',
                isRegistered: '',
                createdAt: '',
                role: '',
                isReseller: false,
                name: '',
                surname: '',
                country: '',
                group: [],
                addresses: []
            },

            billingAddress: {},
            shippingAddress: {},

            userId: userIdFromPath(this.props.location.pathname),

            // controlla se sia stato cliccato nuova mail
            hasClickNewMail: false,
            hasClickResetPassword: false,
            hasClickResetTfa: false,
            hasClickUpdateAddress: false,
            hasClickDeleteUser: false,
            hasClickEditUser: false,
            hasClickRole: false,
            hasClickGroup: false,
            openFilters: true
        }

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        this.getUser();
        this.props.getGroupList();
        if (!isEmpty(this.props.role.role)) {
            this.props.getRoleList();
        }
    }

    componentDidUpdate(prevProps) {
        // navigando da un utente all'altro la pagina non viene rimontata: ricarico i dati del nuovo utente
        const userId = userIdFromPath(this.props.location.pathname);
        if (userId !== this.state.userId) {
            this.setState({ userId, isLoading: true }, this.getUser);
            return;
        }

        // i ruoli arrivano dopo il refresh della pagina
        if (isEmpty(prevProps.role.role) && !isEmpty(this.props.role.role)) {
            this.props.getRoleList();
        }

        // la risposta del BE è arrivata: aggiorno i dati dell'utente.
        // Dopo il primo caricamento aggiorno solo se nella lista c'è questo utente (es. dopo "Rendi reseller"),
        // così una lista caricata per altri motivi non lo fa risultare "non registrato".
        if (prevProps.user.listUser !== this.props.user.listUser) {
            const listUser = this.props.user.listUser || [];
            if (this.state.isLoading || listUser.some(el => el.id === this.state.userId)) {
                this.applyUser(listUser);
            }
        }
    }

    /**
     * Chiama il BE passando determinati filtri, in modo da ricevere tutte le informazioni sull'utente.
     * I dati vengono letti in componentDidUpdate quando arriva la risposta.
     */
    getUser = () => {
        this.props.getUserList({
            'elementsByPage': '1',
            'filters[0][Id]': this.state.userId
        });
    }

    /**
     * Prende dalla lista restituita dal BE l'utente con l'id della pagina.
     * La lista è condivisa con la pagina utenti, quindi cerco per id invece di prendere il primo elemento.
     * Se non c'è, l'utente non è registrato: mostro solo l'email.
     */
    applyUser = (listUser) => {
        const found = (listUser || []).find(el => el.id === this.state.userId);

        if (!found) {
            this.setState({
                isLoading: false,
                billingAddress: {},
                shippingAddress: {},
                userInDetail: { id: '', registrationIp: '', email: this.state.userId, lastLogOn: '', isRegistered: false, createdAt: null, role: '', isReseller: false, group: '', addresses: '', tfa: false }
            });
            return;
        }

        this.setState({
            isLoading: false,
            ...this.favoriteAddresses(found.addresses),
            userInDetail: {
                id: found.id,
                registrationIp: found.registrationIp,
                email: found.email,
                lastLogOn: found.lastLogOn,
                isRegistered: found.isRegistered,
                createdAt: found.createdAt,
                role: found.role,
                isReseller: found.isReseller,
                group: found.groups,
                tfa: found.tfa,
                addresses: found.addresses
            }
        });
    }

    toggleModal = () => {
        this.setState({
            modalMail: false,
            modal: false,
            hasClickNewMail: false,
            hasClickResetPassword: false,
            hasClickResetTfa: false,
            hasClickUpdateAddress: false,
            hasClickRole: false,
            hasClickGroup: false,
            hasClickDeleteUser: false,
            editRole: false,
            editGroup: false,
            editUser: false
        });
    }

    openModalMail = () => {
        this.setState({
            userMail: this.state.userInDetail.id,
            hasClickNewMail: true
        });
        setTimeout(() => {
            this.setState(prevState => ({ modalMail: !prevState.modalMail }));
        }, 100);
    }

    openModalUserInDetail = (action) => {
        if (action === "resetPassword") {
            this.setState({
                titleModal: 'Reset Password',
                contentModal: "Sei sicuro di voler resettare la password dell'utente: " + this.state.userInDetail.id + " ?",
                actionModal: action,
                hasClickResetPassword: true,
            });

        } else if (action === "resetTfa") {
            this.setState({
                titleModal: 'Resetta TFA',
                contentModal: "Sei sicuro di voler resettare il TFA dell'utente: " + this.state.userInDetail.id + " ?",
                actionModal: action,
                hasClickResetTfa: true
            });

        } else if (action === "deleteUser") {
            this.setState({
                titleModal: 'Elimina Utente',
                contentModal: "Sei sicuro di voler eliminare l'utente: " + this.state.userInDetail.id + " ?",
                actionModal: action,
                hasClickDeleteUser: true
            });

        } else if (action === "editUser") {
            this.setState({
                titleModal: this.state.userInDetail.isReseller ? "Rimuovi da Reseller" : "Rendi Reseller",
                contentModal: this.state.userInDetail.isReseller ? "Sei sicuro di voler Rimuovere " + this.state.userInDetail.id + " da Reseller ?" : "Sei sicuro di voler rendere " + this.state.userInDetail.id + " Reseller ?",
                actionModal: action,
                hasClickEditUser: true
            });

        } else if (action === "editAddress") {
            this.setState({
                titleModal: 'Modifica Indirizzi',
                contentModal: "Sei sicuro di voler eliminare l'utente: " + this.state.userInDetail.id + " ?",
                actionModal: action,
                hasClickUpdateAddress: true,
                editUser: true,
            });

        } else if (action === "assignRole") {
            this.setState({
                titleModal: 'Assegna Ruolo',
                actionModal: action,
                hasClickRole: true,
                editRole: true
            });

        } else if (action === "assignGroup") {
            this.setState({
                titleModal: 'Assegna Gruppo',
                actionModal: action,
                hasClickGroup: true,
                editGroup: true
            });
        }

        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 100);
    }

    decideToClick = (actionModal) => {
        if (actionModal === "resetPassword") {
            this.props.resetPassword(this.state.userInDetail);
            this.toggleModal();

        } else if (actionModal === "resetTfa") {
            this.props.resetTfa(this.state.userInDetail);
            this.toggleModal();
            this.props.handleNavigation(this.props.navigate, '/users');

        } else if (actionModal === "deleteUser") {
            this.props.deleteUser(this.state.userInDetail.id);
            this.toggleModal();
            this.props.handleNavigation(this.props.navigate, '/users');


        } else if (actionModal === "editUser") {
            this.updateUser();
            this.toggleModal();

        } else if (actionModal === "editAddress") {
            this.updateAddress();

        } else if (actionModal === "assignRole") {
            this.assignRole();

        } else if (actionModal === "assignGroup") {
            this.assignGroup(this.state.userInDetail);

        }
    }

    /**
     * Invia i dati della mail al BE, e a sua volta invia la mail all'utente
     */
    sendMail = (mail, oggetto, testo) => {
        let data = {
            email: mail,
            subject: oggetto,
            body: testo
        }
        this.toggleModal();
        this.props.sendMail(data);
    }

    /**
     * Invia i dati al BE dopo aver aggiornato l'utente
     */
    assignRole = (data) => {
        this.props.assignRole(data);
        this.toggleModal();
    }

    /**
     * Invia i dati al BE dopo aver aggiornato l'utente
     */
    assignGroup = (data) => {
        this.props.assignGroup(data);
        this.toggleModal();
    }

    /**
     * Invia i dati al BE dopo aver aggiornato l'utente
     */
    updateAddress = (data, id) => {
        this.props.updateAddress(data, id);
        this.toggleModal();
    }

    /**
     * Invia i dati al BE dopo aver aggiornato l'utente
     */
    updateUser = () => {
        let data = {
            id: this.state.userInDetail.id,
            registrationIp: this.state.userInDetail.registrationIp,
            email: this.state.userInDetail.email,
            lastLogOn: this.state.userInDetail.lastLogOn,
            isRegistered: this.state.userInDetail.isRegistered,
            createdAt: this.state.userInDetail.createdAt,
            role: this.state.userInDetail.role,
            isReseller: this.state.userInDetail.isReseller ? false : true,
            tfa: this.state.userInDetail.tfa
        }

        this.props.updateUser(data);
    }

    // indirizzi predefiniti di fatturazione e spedizione
    favoriteAddresses = (addresses) => ({
        billingAddress: (addresses || []).find(el => el.isShipping === false && el.isFavorite === true) || {},
        shippingAddress: (addresses || []).find(el => el.isShipping === true && el.isFavorite === true) || {}
    })

    render() {
        const { role, group } = this.props

        return (
            <Fragment>
                <Page className="userInDetail">
                    <UserHeader
                        loading={this.state.isLoading}
                        userInDetail={this.state.userInDetail}
                        billingAddress={this.state.billingAddress}
                        shippingAddress={this.state.shippingAddress}

                        // l'id della pagina è disponibile prima della risposta del BE: evita chiamate senza filtri
                        userId={this.state.userId}

                        role={role}
                        currentUser={this.props.user.user}
                        infoNotify={this.props.infoNotify}
                        openModalMail={this.openModalMail}
                        openModalUserInDetail={this.openModalUserInDetail}
                    />

                    {
                        !this.state.isLoading &&
                        <ContentDetailUser
                                userInDetail={this.state.userInDetail}
                                setIdPaymentForDetail={this.props.setIdPaymentForDetail}
                                setIdVpnPassForDetail={this.props.setIdVpnPassForDetail}
                                setKeyVpnPassForDetail={this.props.setKeyVpnPassForDetail}
                                setIdPlayerForDetail={this.props.setIdPlayerForDetail}
                                removeVpnPass={this.props.removeVpnPass}
                                handleNavigation={this.props.handleNavigation}

                                // /**
                                //  * Si trova anche in userInDetail, però questo campo nello state viene popolato prima che la pagina venga caricata.
                                //  * Quindi, per evitare problemi (500 o invio senza filtri) con le chiamate al BE, mando anche questa props.
                                //  *
                                userId={this.state.userId}

                                user={this.props.user}
                                role={this.props.role}

                                // chiamata lista dei prodotti su cui può essere creata una PROMO
                                productList={this.props.getProductList}

                                // chiamata per la get delle PROMO
                                getPromoList={this.props.getPromoList}

                                // chiamata per la get delle LICENZE
                                getLicenceList={this.props.getLicenceList}

                                // chiamata per la get dei pagamenti
                                getPaymentList={this.props.getPaymentList}
                                payment={this.props.payment}
                                deletePayment={this.props.deletePayment}
                                deactiveSub={this.props.deactiveSub}
                                refundPayment={this.props.refundPayment}

                                // variabili passate per avere la lista dei gruppi disponibili e la lista dei prodotti
                                group={this.props.group}
                                preferences={this.props.preferences}
                                promo={this.props.promo}

                                sendNewPromo={this.props.sendNewPromo}
                                sendEditPromo={this.props.sendEditPromo}
                                deletePromo={this.props.deletePromo}

                                errorNotify={this.props.errorNotify}
                                successNotify={this.props.successNotify}
                                warningNotify={this.props.warningNotify}
                                infoNotify={this.props.infoNotify}
                            />
                    }
                </Page>

                {
                    this.state.hasClickNewMail &&
                    <ModalMail
                        titleModal="Invio Mail"
                        userMail={this.state.userInDetail.id}
                        successNotify={this.props.successNotify}
                        errorNotify={this.props.errorNotify}
                        warningNotify={this.props.warningNotify}
                        click={this.sendMail}
                        toggle={this.toggleModal}
                        stateModal={this.state.modalMail}
                        key={this.state.userInDetail.id}
                    />
                }

                {
                    (this.state.hasClickResetPassword || this.state.hasClickResetTfa || this.state.hasClickDeleteUser || this.state.hasClickEditUser || this.state.hasClickEditUser) &&
                    <Modal
                        titleModal={this.state.titleModal}
                        contentModal={this.state.contentModal}

                        click={() => this.decideToClick(this.state.actionModal)}

                        toggle={this.toggleModal}
                        stateModal={this.state.modal}
                        key={this.state.userInDetail.id}
                    />
                }

                {

                    (this.state.hasClickUpdateAddress || this.state.hasClickRole || this.state.hasClickGroup) &&
                    <ModalUser
                        titleModal={this.state.titleModal}

                        click={
                            this.state.hasClickUpdateAddress ? this.updateAddress :
                                this.state.hasClickRole ? this.assignRole :
                                    this.state.hasClickGroup ? this.assignGroup :
                                        ''
                        }

                        toggle={this.toggleModal}
                        stateModal={this.state.modal}

                        successNotify={this.props.successNotify}
                        errorNotify={this.props.errorNotify}
                        warningNotify={this.props.warningNotify}

                        email={this.state.userInDetail.id}
                        isReseller={this.state.userInDetail.isReseller}
                        editUser={this.state.editUser}
                        editRole={this.state.editRole}
                        editGroup={this.state.editGroup}
                        groupUser={this.state.userInDetail.group}
                        billingAddress={this.state.billingAddress}
                        shippingAddress={this.state.shippingAddress}

                        key={this.state.userMail}
                        group={group}
                        role={this.state.userInDetail.role}
                        roleList={this.props.role.roleList}
                    />
                }
            </Fragment>
        )
    }
}

export default withNavigate(withLocation(Users));